import { GlAvatarLink, GlAvatar } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { renderMarkdown } from '~/notes/utils';
import TimelineEntryItem from '~/vue_shared/components/notes/timeline_entry_item.vue';
export default {
    name: 'PlaceholderNote',
    directives: {
        SafeHtml
    },
    components: {
        GlAvatarLink,
        GlAvatar,
        TimelineEntryItem
    },
    inject: [
        'currentUserData'
    ],
    props: {
        note: {
            type: Object,
            required: true
        },
        replyNote: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        userUrl () {
            const { path, web_url: webUrl } = this.currentUserData;
            return path || webUrl;
        },
        renderedNote () {
            return renderMarkdown(this.note.body);
        },
        dynamicClasses () {
            return {
                internalNote: {
                    'internal-note': Boolean(this.note.internal)
                },
                noteParent: {
                    card: !this.replyNote,
                    'gl-ml-7': this.replyNote,
                    'gl-ml-8': !this.replyNote
                }
            };
        }
    }
};
